import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09e296cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card overflow-hidden" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "card-img-overlay p-0" }
const _hoisted_5 = { class: "card-info" }
const _hoisted_6 = { class: "card-title pt-2" }
const _hoisted_7 = { class: "card-subTitle text-start m-3" }
const _hoisted_8 = { class: "card-text d-flex justify-content-evenly mt-3" }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isApp)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "img-app",
          src: require(`@/assets/img/${_ctx.img}`)
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("img", {
          key: 1,
          class: "img-web",
          src: require(`@/assets/img/${_ctx.img}`)
        }, null, 8, _hoisted_3)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.title), 1),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.des), 1),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.view)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "btn btn-secondary",
                href: _ctx.view,
                target: "_blank"
              }, "View", 8, _hoisted_9))
            : _createCommentVNode("", true),
          (_ctx.code)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "btn btn-secondary",
                href: _ctx.code,
                target: "_blank"
              }, "Code", 8, _hoisted_10))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}